import React, { useState, useEffect } from "react";
import "./Customer.css";

const ScrollToBottomButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    if (window.pageYOffset < 50) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const scrollToBottom = () => {
    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);
    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, []);

  return (
    <div className="scroll-to-bottom">
      {isVisible && (
        <button onClick={scrollToBottom} className="scroll-to-bottom-button">
          ↓
        </button>
      )}
    </div>
  );
};

export default ScrollToBottomButton;
